import React, { useState } from 'react';
import styles from './HowItWorks.module.css';
import { useNavigate } from 'react-router-dom';
import roydon from "../assets/roydon.jpg"
import yadu from "../assets/yadu.jpg"
import kunal from "../assets/kunal.jpg"
import prass from "../assets/prasanna.jpg"



const HowItWorks = () => {
  const navigate = useNavigate();

  const testimonials = [
    {
    feedback: "Incredible tool for tracking progress—our team loves it!",
    name: "yadhu",
    title: "",
    image: yadu,
  },
  {
    feedback: "The Timing Gate transformed how we train—now every second counts!",
    name: "Prasanna Kumar",
    title: "Athlete",
    image: prass,
  },
  {
    feedback: "This system has elevated our training to the next level!",
    name: "Kunal Paul",
    title: "Athlete",
    image: kunal,
  },
    {
    feedback: "A game-changer for athlete training - precise, easy to use, and cost-effective!",
    name: "Roydon Pinto",
    title: "Athlete",
    image: roydon,
  },
];


  const [startIndex, setStartIndex] = useState(0);

  const handleNext = () => {
    if (startIndex + 3 < testimonials.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const displayedTestimonials = testimonials.slice(startIndex, startIndex + 3);

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>How It Works</h2>

  {/* Embedded PNG instead of SVG */}
  <img src={require('../assets/aikyamSteps3.jpg')} alt="Aikyam Steps" className={styles.aikyamSvg} />


<div className={styles.buttonWrapper}>
  <button className={styles.demoButton} aria-label="Book a Timing Gate demonstration" onClick={() => navigate('/booking')}>Book a Demo</button>
  <button className={styles.demoButton}>Pre-Book</button>
</div>


      <div className={styles.testimonialsSection}>
        <h2 className={styles.testimonialsTitle}>Testimonials</h2>
        <div className={styles.testimonialsWrapper}>
          {displayedTestimonials.map((testimonial, index) => (
            <div key={index} className={styles.testimonialCard}>
              <div className={styles.stars}>
                {[...Array(5)].map((_, i) => (
                  <svg key={i} className={styles.starIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21L12 17.77L5.82 21L7 14.14L2 9.27L8.91 8.26L12 2Z"
                      fill="#FF0000"
                    />
                  </svg>
                ))}
              </div>
              <p className={styles.feedback}>"{testimonial.feedback}"</p>
              <div className={styles.reviewer}>
                <img src={testimonial.image} alt={`${testimonial.name} testimonial for Aikyam Timing Gate`} className={styles.reviewerImage} />
                <div className={styles.reviewerInfo}>
                  <p className={styles.reviewerName}>{testimonial.name}</p>
                  <p className={styles.reviewerTitle}>{testimonial.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.navigationArrows}>
          <button
            onClick={handlePrev}
            className={`${styles.arrowButton} ${startIndex === 0 ? styles.disabled : ''}`}
            disabled={startIndex === 0}
          >
            <svg className={styles.arrowIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <button
            onClick={handleNext}
            className={`${styles.arrowButton} ${startIndex + 3 >= testimonials.length ? styles.disabled : ''}`}
            disabled={startIndex + 3 >= testimonials.length}
          >
            <svg className={styles.arrowIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="#666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div> 
      </div>
    </div>
  );
};

export default HowItWorks;
